export default "__VITE_ASSET__BvI3_iPw__"